// User reducer action types
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const SET_USER_PROFILE_FIELD = "SET_USER_PROFILE_FIELD";

// Movie reducer action types
export const SET_MOVIE_REVIEW_USER_INFO = "SET_MOVIE_REVIEW_USER_INFO";
export const SET_MOVIE_REVIEWS = "SET_MOVIE_REVIEWS";
export const SET_MOVIE_FIELD = "SET_MOVIE_FIELD";

// Error reducer action types
export const CLEAR_ERROR = "CLEAR_ERROR";
export const SET_ERROR_FIELD = "SET_ERROR_FIELD";

// Advanced search reducer action types
export const SET_ADVANCED_SEARCH_FIELD = "SET_ADVANCED_SEARCH_FIELD";

// User movie form reducer action types
export const SET_USER_MOVIE_FORM_SEARCH = "SET_USER_MOVIE_FORM_SEARCH";
